import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography
} from '@mui/material';

interface OffsetModalProps {
  visible: boolean;
  onDismiss: () => void;
  onAccept: (offset: string) => void;
  previousValue: number;
  offset: string;
}

const OffsetModal: React.FC<OffsetModalProps> = ({
  visible,
  onDismiss,
  onAccept,
  previousValue,
  offset: channelOffset
}) => {
  const [offsetFeet, setOffsetFeet] = useState(0);
  const [offsetInches, setOffsetInches] = useState(0);

  const parseFeetAndInches = (value: string) => {
    const [feetStr, inchesStr] = value.split("'");
    const feet = parseInt(feetStr, 10) || 0;
    const inches = parseInt(inchesStr, 10) || 0;
    return { feet, inches };
  };

  useEffect(() => {
    if (visible && channelOffset) {
      const { feet, inches } = parseFeetAndInches(channelOffset);
      setOffsetFeet(feet);
      setOffsetInches(inches);
    }
  }, [visible, channelOffset]);

  const handleChangeFeet = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOffsetFeet(parseInt(event.target.value, 10) || 0);
  };

  const handleChangeInches = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOffsetInches(parseInt(event.target.value, 10) || 0);
  };

  const handleAccept = () => {
    const totalOffset = offsetFeet * 12 + offsetInches;
    onAccept(totalOffset.toString());
    onDismiss();
  };

  return (
    <Dialog open={visible} onClose={onDismiss}>
      <DialogTitle>Set Offset</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Typography variant="subtitle1">Feet</Typography>
            <TextField
              type="number"
              value={offsetFeet}
              onChange={handleChangeFeet}
              fullWidth
              inputProps={{ min: 0, max: 500 }}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">Inches</Typography>
            <TextField
              type="number"
              value={offsetInches}
              onChange={handleChangeInches}
              fullWidth
              inputProps={{ min: 0, max: 9, step: 3 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleAccept} color="primary">
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OffsetModal;
